<template>
    <div class="settings-invoices">
        <div class="taxes">
            <h4 class="section-title">{{ $page.props.lang.taxesSettings || 'Taxes settings' }}</h4>
            <div class="filter-section tax-types">
                <v-checkbox
                v-model="taxesData.taxes_enabled" class="enable" 
                :label="$page.props.lang.taxesEnabled || 'Taxes Enabled'" hide-details></v-checkbox>
                <div class="flex">
                    <div class="field-group">
                        <p class="custom-label">{{ $page.props.lang.taxCalculationTypes || 'Tax calculation type' }}</p>
                        <v-select 
                        :items="tax_types" v-model="taxesData.tax_calculation_type" class="select" 
                        :disabled="!taxesData.taxes_enabled"
                        item-text="text" 
                        background-color="#FFFFFF" dense outlined hide-details>
                        </v-select>
                    </div>
                    <div class="field-group">
                        <p class="custom-label">{{ $page.props.lang.percentage || 'Percentage' }}</p>
                        <v-text-field v-model="taxesData.tax_pct" :disabled="!taxesData.taxes_enabled" 
                        background-color="#FFFFFF" outlined dense append-icon="mdi-percent-outline" class="tax-pct"
                        :error-messages="responseErrors.tax_pct" @focus="responseErrors.tax_pct=''"></v-text-field>
                    </div>
                    <v-btn @click="saveTaxes" :disabled="!taxesData.taxes_enabled" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                </div>
            </div>
        </div>
        <div class="invoices">
            <h4 class="section-title">{{ $page.props.lang.invoiceNumberFormat || 'Invoice number format' }}</h4>
            <div class="filter-section invoices-settings">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.invoiceNumberPrefix || 'Invoice Number Prefix' }}</p>
                    <v-text-field v-model="invoiceData.prefix" @input="setInvoicePreview"
                    background-color="#FFFFFF" outlined dense class="prefix"></v-text-field>
                </div>
                <v-checkbox v-model="invoiceData.year" @change="setInvoicePreview" class="year-check" :label="$page.props.lang.useCurrentYear || 'Use Current Year'" hide-details></v-checkbox>
                <v-checkbox v-model="invoiceData.month" @change="setInvoicePreview" 
                :disabled="invoiceMonthDisabled" class="month-check" :label="$page.props.lang.useCurrentMonth || 'Use Current Month'" hide-details></v-checkbox>
                <div class="preview">
                    <p class="custom-label">{{ $page.props.lang.exampleOfInvoiceNumber || "Example Of Invoice Number" }}</p>
                    <p class="number">{{ invoicePreview }}</p>
                </div>
                <v-btn @click="saveInvoice" color="primary" dark>{{ $page.props.lang.save || "Save" }}</v-btn>
            </div>
        </div>
        
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.invoices || "Invoices"
        }
    },
    props: {
        settings: Object,
        lang: Object,
    },
    data() {
        return {
            taxesData: {
                taxes_enabled: this.settings.taxes_enabled,
                tax_calculation_type: this.settings.tax_calculation_type,
                tax_pct: this.settings.tax_pct
            },
            tax_types: [
                {value: 'exclusive', text: this.lang.exclusive || 'Exclusive'}, 
                {value: 'inclusive', text: this.lang.inclusive || 'Inclusive'}
            ],
            invoicePreview: '',
            invoiceMonthDisabled: true,
            responseErrors: {}
        }
    },
    computed: {
        invoiceData() {
            return {
                prefix: this.settings.invoice_number_prefix === null ? '' : this.settings.invoice_number_prefix,
                year: this.settings.invoice_number_year === 0 ? false : true,
                month: this.settings.invoice_number_month === 0 ? false : true
            }
        }
    },
    watch: {
        'invoiceData.prefix'(value) {
            if (value === '') {
                this.setInvoicePreview()
            }
        },
    },
    mounted() {
        this.setInvoicePreview()
    },
    methods: {
        setInvoicePreview() {
            if (this.invoiceData.year === false) {
                this.invoiceData.month = false
                this.invoiceMonthDisabled = true
            } else {
                this.invoiceMonthDisabled = false
            }
            this.invoicePreview = '1'
            this.invoiceData.month === true ? this.invoicePreview = moment().format('MM') + '-' + this.invoicePreview : ''
            this.invoiceData.year === true ? this.invoicePreview = moment().format('YYYY') + '-' + this.invoicePreview : ''
            this.invoiceData.prefix !== '' ? this.invoicePreview = this.invoiceData.prefix + '-' + this.invoicePreview : ''
        },
        saveInvoice() {
            let invoicePack = {
                invoice_number_prefix: this.invoiceData.prefix === '' ? null : this.invoiceData.prefix,
                invoice_number_year: this.invoiceData.year === false ? 0 : 1,
                invoice_number_month: this.invoiceData.month === false ? 0 : 1
            }
            axios.post('/backoffice/settings/saveInvoice', invoicePack)
                .then(response => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
        saveTaxes() {
            axios.post('/backoffice/settings/saveTaxes', this.taxesData)
                .then(response => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
    }
}
</script>